import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import Context from "../../../Context.js";
import NavBar from "./NavBar.js";

import BrandContainerHoz from "../../brand/BrandContainerHoz.js";
import NavBarMobile from "./NavBarMobile.js";
import ColorThemeSelector from "./ColorThemeSelector.js";
import BrandContainerJustText from "../../brand/BrandContainerJustText.js";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const TopPart = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ collapsed }) => (collapsed ? "0px" : "265px")};
  margin-top: 20px;
  margin-left: ${({ collapsed }) => (collapsed ? "0px" : "20px")};
  height: calc(100vh - 40px);
  justify-content: space-between;
  top: 20px;
  position: sticky;
  overflow: hidden;
  z-index: 100;
  border: ${({ collapsed }) => (collapsed ? "0px" : "1px solid var(--border)")};
  background: ${({ collapsed }) => (collapsed ? "transparent" : "var(--headerSurface)")};
  border-radius: 10px;
  padding: ${({ collapsed }) => (collapsed ? "0px" : "30px 20px")};
  animation: centerScaleReveal 0.6s ease-in-out forwards;
  transition: all 0.35s ease;
  transform: ${({ collapsed }) => (collapsed ? "translateX(-40px)" : "translateX(0)")};
  opacity: ${({ collapsed }) => (collapsed ? 0 : 1)};
  pointer-events: ${({ collapsed }) => (collapsed ? "none" : "auto")};
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 5px;
  min-height: 0;
  flex: 1;
`;

const ToggleButton = styled.button`
  align-self: flex-end;
  background: var(--headerElementDim);
  color: var(--headerSurface);
  border: none;
  border-radius: 12px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--lightShadow);

  &:hover {
    background: var(--headerAccent);
    color: var(--headerAccentAlt);
  }
`;

const BrandWrapper = styled.div`
  display: flex;
  justify-content: ${({ collapsed }) => (collapsed ? "center" : "flex-start")};
  padding-left: ${({ collapsed }) => (collapsed ? "0" : "4px")};
`;

const FloatingToggle = styled(ToggleButton)`
  position: fixed;
  left: 12px;
  top: 24px;
  z-index: 200;
  background: var(--headerSurface);
  color: var(--headerAccent);
  border: 1px solid var(--border);
  opacity: 0.9;
  transition: all 0.25s ease;

  &:hover {
    opacity: 1;
    transform: translateX(2px);
  }
`;

export default function LoggedInHeader() {
  const { loggedInUser, isMobile } = useContext(Context);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    try {
      let cached = localStorage.getItem("cs-nav-collapsed");
      if (cached) setCollapsed(cached === "true");
    } catch (e) {}
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem("cs-nav-collapsed", collapsed ? "true" : "false");
    } catch (e) {}
  }, [collapsed]);

  if (!loggedInUser) return null;

  if (isMobile) {
    return <NavBarMobile />;
    //  return <NavBarWithInvertedCurve />;
  }

  return (
    <>
      {collapsed ? (
        <FloatingToggle onClick={() => setCollapsed(false)}>
          <FiChevronRight />
        </FloatingToggle>
      ) : null}

      <TopPart collapsed={collapsed}>
        {!collapsed && (
          <>
            <BrandWrapper collapsed={collapsed}>
              <BrandContainerJustText style={{ color: "var(--headerAccent)" }} />
            </BrandWrapper>

            <ToggleButton onClick={() => setCollapsed(true)}>
              <FiChevronLeft />
            </ToggleButton>

            <Right>
              <NavBar collapsed={collapsed} />
              <ColorThemeSelector
                surfaceColor={"var(--headerSurface)"}
                elementColor={"var(--headerElement)"}
                accentColor={"var(--headerAccent)"}
                accentAltColor={"var(--headerAccentAlt)"}
              />
            </Right>
          </>
        )}
      </TopPart>
    </>
  );
}
